import React, { Component } from 'react'

const FAQ_DATA = [
    {
        question: "豆花含有哪些過敏原？",
        answer: "我們的豆花主要成分為黃豆，部分配料含有花生、芝麻等。如有特殊過敏需求，請於點餐時告知店員。"
    },
    {
        question: "有提供素食/純素選項嗎？",
        answer: "我們的豆花本身為素食，大部分配料也是素食。部分配料如蜂蜜不適合純素飲食，點餐時可以選擇搭配糖水。"
    },
    {
        question: "外送服務的範圍？",
        answer: "目前透過 Uber Eats 及 Foodpanda 提供外送服務，配送範圍依各平台規定。您也可以透過官方線上訂餐系統訂購自取。"
    },
    {
        question: "如何加入 LINE 會員？",
        answer: "到店掃描櫃台 QR Code 即可加入豆日子 LINE 官方帳號，享有會員集點及不定期優惠活動。"
    },
    {
        question: "可以團體訂購或外燴嗎？",
        answer: "歡迎！我們提供團購及外燴服務，10碗以上即享優惠。請透過聯絡表單或來電洽詢：02-86617800。"
    }
];

class FAQAccordion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openIndex: -1
        };
    }

    toggleFAQ(index) {
        this.setState({
            openIndex: this.state.openIndex === index ? -1 : index
        });
    }

    render() {
        var self = this;
        return (
            <div className="faq_section">
                <h3 className="faq_title">常見問題</h3>
                {FAQ_DATA.map(function(item, index) {
                    var isOpen = self.state.openIndex === index;
                    return (
                        <div key={index} className={"faq_item" + (isOpen ? " open" : "")}>
                            <button className="faq_question" onClick={function() { self.toggleFAQ(index); }}>
                                <span>{item.question}</span>
                                <span className="faq_chevron">&#9662;</span>
                            </button>
                            <div className="faq_answer">
                                <p>{item.answer}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default FAQAccordion;
